import { VariableService } from 'src/app/services/variable.service';
import { ClientDataService } from './../client-data.service';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import pdfMake from './../../../assets/datatable/js/pdfmake.min.js'; //'pdfmake/build/pdfmake';
import pdfFonts from './../../../assets/datatable/js/vfs_fonts.js'; //'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import * as IFA_logoFile from './../../../assets/IFA_logo.js';

import { DefaultCompanyLogoBs64 } from './../../validation';
import { NseService } from '../nse.service';
import { isNullOrUndefined } from 'util';
import { environment } from 'src/environments/environment';
import { ReportService } from '../report.service';
import { Observable, Subject } from 'rxjs';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
@Injectable({
  providedIn: 'root'
})
export class PdfService {
  myDate = new Date();
  // disclaimer = 'This statement/report is computer generated and based on the information available to us with the help of different data sources and service providers. We strive to keep our records updated at all times. However, there may be delays in updating our records or there may be changes that we are not aware of.If you come across any errors or omissions please inform us immediately. We will not accept liability for any claims for damages/loss arising from an inaccurate record or any incident with this platform and its services. Any valuations quoted are the most recent available to us, hence any discrepancy found in the statement or any other incidents or errors, please inform us immediately. The tax calculations are made based on our interpretation of the Income Tax Act. Please contact your Accountant/Tax consultant for the exact calculations. Maturity Date wherever displayed is based on available information.';
  disclaimer =
    'This statement/report is computer system generated, based on the information available with the help of different data sources and service providers.' +
    '\n' +
    'I am/We are an AMFI Registered Distributor. Any valuations quoted are the most recent available. However, there may be delays in updating the records or there may be changes that we are not aware of. If the reader comes across any errors or omissions, please inform us immediately.' +
    '\n' +
    'I/We shall not take any responsibility for any error, omission, inaccuracy, or mistake of any nature, or any consequences of the use of the material/information provided in the report, and I/We shall not be held liable for any direct or indirect damages or loss, if any, resulting from any investment made by the investors.' +
    '\n' +
    'The tax calculations are made based on our interpretation of the Income Tax Act. Tax benefits are as per extant tax laws and are subject to changes. Investors should consult their tax consultant for any taxation advice/implications.The maturity date, wherever displayed, is based on available information.' +
    '\n' +
    'The information provided herein is meant only for general reading purposes and the views being expressed only constitute opinions. Investments in mutual funds should not be construed as a guarantee of any minimum returns. Past performance may or may not be sustained in the future. There is no capital protection guarantee or assurance of any return in mutual fund investments.' +
    '\n' +
    'Investors alone shall be fully responsible/liable for any decision taken in mutual fund investments. Mutual fund investments are subject to market risks; read all scheme-related documents carefully.';
  todaysDate = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
  pdfMailSubjectObj = new Subject<string>();
  constructor(
    private datePipe: DatePipe,
    private cds: ClientDataService,
    private NSE: NseService,
    private report: ReportService,
    private AppVariable: VariableService,
    private EncrdecrService: EncrdecrService
  ) { }

  //********* added by Mohit on 30-09-2020 for dynamic PDF generate  *********/
  generatePDF(PdfName, Content, clientname?) {
    debugger;
    let CompanyLogo = '';
    let TopImage = '';
    let BottomImage = '';

    //#region - Dynamic Logo Logic for Corporate and IFA
    let Flag = sessionStorage.getItem('Vbhs@#%LMKIo='); //Flag > C = Corporate | I = IFA

    debugger;

    debugger;
    let logo = sessionStorage.getItem('pi4ZU2P3M8JE4q7');

    if (logo != null && logo != '' && logo != undefined && logo != 'null') {
      // CompanyLogo = logo.toString(); comment by adarsh
      //added by adarsh from here
      if (environment.CompayName == 'IFA' && environment.IsOptimoney == false) {
        CompanyLogo =
          'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh=='); //added by adarsh
      } else {
        CompanyLogo = logo.toString();
      }
      //to here
    } else {
      CompanyLogo = IFA_logoFile.logoBase64; //Default Logo Image if logo is null
    }
    debugger;
    TopImage = IFA_logoFile.TopImage;
    BottomImage = IFA_logoFile.BottomImage;

    //}
    //}
    //#endregion
    debugger;
    var dd = {
      //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
      pageSize: 'A4',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 85, 20, 20],

      header: function (currentPage, _pageCount, _pageSize) {
        let PdfHeaderImg = '';
        ////
        if (Flag === 'C') {
          //corporate
          if (currentPage == 1) {
            PdfHeaderImg = TopImage;
          } else {
            PdfHeaderImg = BottomImage;
          }
          return [
            {
              image: PdfHeaderImg,
              //image: pdfLogo,
              absolutePosition: {
                // image positioning from margin
                x: 20,
                y: 20
              },
              width: 800,
              height: 95, //image size increase/decrease
              margin: [0, 50, 0, 10] // [left, top, right, bottom]
            }
          ];
        } else {
          //IFA
          if (currentPage == 1) {
            PdfHeaderImg = TopImage;
          } else {
            PdfHeaderImg = BottomImage;
          }
          return [
            {
              image: PdfHeaderImg,
              //image: pdfLogo,
              absolutePosition: {
                // image positioning from margin
                x: 20,
                y: 20
              },

              width: 800,
              height: 54, //image size increase/decrease before height is 50
              margin: [0, 80, 0, 10] // [left, top, right, bottom]
            },
            {
              image: CompanyLogo,
              //image: pdfLogo,
              absolutePosition: {
                // image positioning from margin
                x: 720,
                y: 20
              },
              width: 100,
              height: 50 //image size increase/decrease
              //margin: [0, 50, 0, 10],// [left, top, right, bottom]
            }
          ];
        }
      },

      content: [Content],

      footer: (currentPage, totalPage) => {
        return [
          {
            text: ` Page ${currentPage.toString()} of ${totalPage.toString()}`,
            alignment: 'right',
            fontSize: 7,
            margin: [20, 0]
          },
          {
            text: 'This report is not valid without the Disclosure & Disclaimer',
            alignment: 'left',
            fontSize: 7,
            margin: [20, 0]
          }
        ];
      },

      styles: {
        Aboveheader: {
          fontSize: 10,
          bold: true,
          margin: [0, 5, 0, 10],
          color: '#000',
          text: 'Uppercase'
        },
        AMFIText: {
          // bold: true,
          fontSize: 8,
          color: 'rgb(0 0 0 / 70%)',
          margin: [0, 10, 0, 0],
          text: 'Uppercase'
        },
        PreparedFor: {
          fontSize: 12,
          bold: true,
          margin: [0, 20, 0, 20],
          color: '#000',
          text: 'Uppercase'
        },
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 20, 0, 8],
          color: '#000',
          text: 'Uppercase'
        },
        subheader: {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 4],
          color: '#000'
        },
        ReportDate: {
          alignment: 'centre',
          color: '#000'
        },
        tableExample: {
          //fontSize: 10,
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          fontSize: 10,
          bold: true
        }
      },
      defaultStyle: {
        //font : 'SegoeUI',
        fontSize: 7,
        color: '#000'
      }
    };
    //pdfMake.fonts = {
    //  SegoeUI: {
    //    normal: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf',
    //    bold: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf',
    //    italics: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-italic.ttf',
    //    bolditalics: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600italic.ttf'
    //  }
    //}
    debugger;
    let name =
      !isNullOrUndefined(clientname) && clientname != ''
        ? `_${clientname.trim()}`
        : '';
    pdfMake.createPdf(dd).download(`${PdfName}_${this.todaysDate}${name}.pdf`);
    //pdfMake.createPdf(dd).open();
  }

  getBase64FromPDF(_PdfName, Content, ClientBasicInfoId, subBrokerId?) {
    //#region
    let BaseString = '';
    let CompanyLogo = '';
    let TopImage = IFA_logoFile.TopImage;
    let BottomImage = IFA_logoFile.BottomImage;

    //#region - Dynamic Logo Logic for Corporate and IFA
    let Flag = sessionStorage.getItem('Vbhs@#%LMKIo='); //Flag > C = Corporate | I = IFA
    //let Flag=sessionStorage.getItem("Vbhs@#%LMKIo=") == null ? "IFA":sessionStorage.getItem("Vbhs@#%LMKIo=");
    if (Flag != null && Flag != '' && Flag != undefined) {
      debugger;

      debugger;
      let logo = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
      if (logo != null && logo != '' && logo != undefined && logo != 'null') {
        //added by adarsh from here
        if (
          environment.CompayName == 'IFA' &&
          environment.IsOptimoney == false
        ) {
          CompanyLogo =
            'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh=='); //added by adarsh
        } else {
          CompanyLogo = logo.toString();
        }
        //to here
      } else {
        CompanyLogo = IFA_logoFile.logoBase64; //Default Logo Image if logo is null
      }
      debugger;
      TopImage = IFA_logoFile.TopImage;
      BottomImage = IFA_logoFile.BottomImage;
    }
    //#endregion
    var dd = {
      //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
      pageSize: 'A4',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 85, 20, 20],

      header: function (currentPage, _pageCount, _pageSize) {
        let PdfHeaderImg = '';
        ////
        if (Flag === 'C') {
          //corporate
          if (currentPage == 1) {
            PdfHeaderImg = TopImage;
          } else {
            PdfHeaderImg = BottomImage;
          }
          return [
            {
              image: PdfHeaderImg,
              //image: pdfLogo,
              absolutePosition: {
                // image positioning from margin
                x: 20,
                y: 20
              },
              width: 800,
              height: 95, //image size increase/decrease
              margin: [0, 50, 0, 10] // [left, top, right, bottom]
            }
          ];
        } else {
          //IFA
          if (currentPage == 1) {
            PdfHeaderImg = TopImage;
          } else {
            PdfHeaderImg = BottomImage;
          }
          return [
            {
              image: PdfHeaderImg,
              //image: pdfLogo,
              absolutePosition: {
                // image positioning from margin
                x: 20,
                y: 20
              },

              width: 800,
              height: 54, //image size increase/decrease before height is 50
              margin: [0, 80, 0, 10] // [left, top, right, bottom]
            },
            {
              image: CompanyLogo,
              //image: pdfLogo,
              absolutePosition: {
                // image positioning from margin
                x: 720,
                y: 20
              },
              width: 100,
              height: 50 //image size increase/decrease
              //margin: [0, 50, 0, 10],// [left, top, right, bottom]
            }
          ];
        }
      },

      content: [Content],

      footer: (currentPage, totalPage) => {
        return [
          {
            text: ` Page ${currentPage.toString()} of ${totalPage.toString()}`,
            alignment: 'right',
            fontSize: 7,
            margin: [20, 0]
          },
          {
            text: 'This report is not valid without the Disclosure & Disclaimer',
            alignment: 'left',
            fontSize: 7,
            margin: [20, 0]
          }
        ];
      },

      styles: {
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 60, 0, 40],
          color: '#000',
          text: 'Uppercase'
        },
        subheader: {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 4],
          color: '#000'
        },
        ReportDate: {
          alignment: 'right',
          color: '#000'
        },
        tableExample: {
          //fontSize: 10,
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          fontSize: 10,
          bold: true
        }
      },
      defaultStyle: {
        //font : 'SegoeUI',
        fontSize: 7,
        color: '#000'
      }
    };

    //#endregion
    // code by satyam - 09/03/2023 ==> (Mail Report To Client,SubBroker)

    debugger;
    BaseString = pdfMake.createPdf(dd).getBase64((data) => {
      // return BaseString
      this.NSE.sendPdfReportToClient(
        data,
        _PdfName,
        ClientBasicInfoId
      ).subscribe((data) => {
        debugger;
        let output = JSON.stringify(data);
        this.pdfMailSubjectObj.next(output);
      });
    });
  }

  // getBase64FromPDF(_PdfName, Content, ClientBasicInfoId,subBrokerId?){
  //   //#region
  //   let BaseString = '';
  //   let CompanyLogo = '';
  //    let TopImage = IFA_logoFile.TopImage;
  //      let BottomImage = IFA_logoFile.BottomImage;

  //   //#region - Dynamic Logo Logic for Corporate and IFA
  //   let Flag = sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
  //   //let Flag=sessionStorage.getItem("Vbhs@#%LMKIo=") == null ? "IFA":sessionStorage.getItem("Vbhs@#%LMKIo=");
  //   if (Flag != null && Flag != "" && Flag != undefined) {
  //     debugger;

  //       debugger;
  //       let logo = sessionStorage.getItem("pi4ZU2P3M8JE4q7");
  //       if (logo != null && logo != "" && logo != undefined && logo != "null") {
  //         //added by adarsh from here
  //         if(environment.CompayName == 'IFA' && environment.IsOptimoney == false)
  //         {
  //           CompanyLogo = 'data:image/jpg;base64,'+ sessionStorage.getItem('lkighty445dh==');//added by adarsh
  //         }
  //         else{
  //           CompanyLogo = logo.toString();
  //         }
  //         //to here
  //       }
  //       else {
  //         CompanyLogo = IFA_logoFile.logoBase64; //Default Logo Image if logo is null
  //       }
  //       debugger;
  //       TopImage = IFA_logoFile.TopImage;
  //       BottomImage = IFA_logoFile.BottomImage;

  //   }
  //   //#endregion
  //   var dd = {
  //     //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
  //     pageSize: 'A4',
  //     // by default we use portrait, you can change it to landscape if you wish
  //     pageOrientation: 'landscape',
  //     // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
  //     pageMargins: [20, 130, 20, 20],

  //     header: function (currentPage, _pageCount, _pageSize) {
  //       let PdfHeaderImg = '';
  //       ////
  //       if (Flag === "C") { //corporate
  //         if (currentPage == 1) {
  //           PdfHeaderImg = TopImage;
  //         }
  //         else {
  //           PdfHeaderImg = BottomImage;
  //         }
  //         return [
  //           {
  //             image: PdfHeaderImg,
  //             //image: pdfLogo,
  //             absolutePosition: {  // image positioning from margin
  //               x: 20, y: 20
  //             },
  //             width: 800, height: 95, //image size increase/decrease
  //             margin: [0, 50, 0, 10],// [left, top, right, bottom]
  //           },
  //         ]
  //       }
  //       else { //IFA
  //         if (currentPage == 1) {
  //           PdfHeaderImg = TopImage;
  //         }
  //         else {
  //           PdfHeaderImg = BottomImage;
  //         }
  //         return [
  //           {
  //             image: PdfHeaderImg,
  //             //image: pdfLogo,
  //             absolutePosition: {  // image positioning from margin
  //               x: 20, y: 20
  //             },

  //             width: 800, height: 95, //image size increase/decrease
  //             margin: [0, 50, 0, 10],// [left, top, right, bottom]
  //           },

  //           {
  //             image: CompanyLogo,
  //             //image: pdfLogo,
  //             absolutePosition: {  // image positioning from margin
  //               x: 720, y: 20
  //             },
  //             width: 100, height: 45, //image size increase/decrease
  //             //margin: [0, 50, 0, 10],// [left, top, right, bottom]
  //           }
  //         ]
  //       }
  //     },

  //     content: [
  //       Content,

  //     ],

  //     footer: (currentPage, totalPage) => {
  //       return {
  //         text: `Page ${currentPage.toString()} of ${totalPage.toString()}`,
  //         alignment: 'right',
  //         fontSize: 7,
  //         margin: [20, 0]
  //       }
  //     },

  //     styles: {
  //       header: {
  //         fontSize: 16,
  //         bold: true,
  //         margin: [0, 30, 0, 10],
  //         color: '#000'
  //       },
  //       subheader: {
  //         fontSize: 13.5,
  //         bold: true,
  //         margin: [0, 10, 0, 5],
  //         color: '#000'
  //       },
  //       ReportDate: {
  //         alignment: 'right',
  //         color: '#000'
  //       },
  //       tableExample: {
  //         //fontSize: 10,
  //         margin: [0, 5, 0, 15],
  //       },
  //       tableHeader: {
  //         fontSize: 10,
  //         bold: true
  //       },
  //     },
  //     defaultStyle: {
  //       //font : 'SegoeUI',
  //       fontSize: 9,
  //       color: '#434343'
  //     }
  //   }

  //   //#endregion
  //   // code by satyam - 09/03/2023 ==> (Mail Report To Client,SubBroker)

  //   debugger;
  //   BaseString = pdfMake.createPdf(dd).getBase64((data) => {
  //     // return BaseString
  //     this.NSE.sendPdfReportToClient(data,_PdfName,ClientBasicInfoId).subscribe((data) => {
  //       debugger;
  //       let output = JSON.stringify(data);
  //       this.pdfMailSubjectObj.next(output);

  //     });
  //   });

  // }

  // Func to return generated table
  table(data, columns, witdhsDef, showHeaders, headers, requiredFooter = true) {
    let TableLength = data.length;
    return {
      style: 'tableExample',
      table: {
        headerRows: 1,
        dontBreakRows: true,
        widths: witdhsDef,
        style: 'tableHeader',
        body: this.buildTableBody(data, columns, showHeaders, headers)
      },
      // Table Styles
      layout: {
        hLineWidth: function (i, _node) {
          return i === 1 ? 1 : 0;
        },
        vLineWidth: function (_i, _node) {
          return 0;
        },
        hLineColor: function (i, _node) {
          return i === 1 ? '#fff' : '#fff';
        },
        vLineColor: function (_i, _node) {
          return '#fff';
        },
        paddingBottom: function (_i, _node) {
          return 5;
        },
        paddingTop: function (_i, _node) {
          return 5;
        },
        fillColor: function (rowIndex, _node, _columnIndex) {
          ////////
          switch (rowIndex) {
            case 0:
              return '#f8faff';
              break;
            default:
              if (rowIndex == TableLength) {
                if (requiredFooter) {
                  let rr: any = data[TableLength];
                  return '#f2f5ff';
                } else {
                  return rowIndex % 2 === 0 ? '#f7f7f7' : '#fff';
                }
              } else {
                return rowIndex % 2 === 0 ? '#f7f7f7' : '#fff';
              }
              break;
          }
        }
      }
    };
  }
  // Table body builder
  buildTableBody(data, columns, showHeaders, headers) {
    var body = [];
    // Inserting headers
    if (showHeaders) {
      body.push(headers);
    }
    // Inserting items from external data array
    data.forEach(function (row) {
      var dataRow = [];
      var i = 0;
      columns.forEach(function (column) {
        if (headers[i])
          dataRow.push({
            text: row[column],
            alignment: headers[i].alignmentChild
          });
        else {
          // console.log('@@@@', JSON.stringify(row[column]), headers[i], i);
          // console.log('12#', JSON.stringify(headers[i - 1]), headers[i - 2]);
        }
        i++;
      });
      body.push(dataRow);
    });
    return body;
  }
  //--------------------------------------------------------------------------------------------------

  generatePdf(
    pdfName,
    pdfData,
    pdfLogo,
    ClientName,
    ClientPAN,
    SubbrokerName,
    pdfHeader_Width,
    UserType,
    ClientRMName,
    ClientRMContact
  ) {
    debugger;
    let TodaysDate = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
    const documentDefinition = this.getDocumentDefinition(
      pdfName,
      pdfData,
      pdfLogo,
      ClientName,
      ClientPAN,
      SubbrokerName,
      pdfHeader_Width,
      UserType,
      ClientRMName,
      ClientRMContact
    );
    pdfMake
      .createPdf(documentDefinition)
      .download(`${pdfName}_${TodaysDate}.pdf`);
  }

  getDocumentDefinition(
    pdfName,
    pdfData,
    _pdfLogo,
    ClientName,
    ClientPAN,
    _SubbrokerName,
    pdfHeader_Width,
    UserType,
    ClientRMName,
    ClientRMContact
  ) {
    debugger;
    let TodaysDate = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
    var DynamicClientInfo: any;
    debugger;
    if (ClientName == '' && pdfName != 'Dividend Report') {
      DynamicClientInfo = {
        text: 'Report Generated Date : ' + TodaysDate,
        fontSize: 10,
        style: 'ReportDate'
      };
    } else {
      let Text: string = '';
      Text =
        parseInt(UserType) == 1
          ? 'Relationship Manager         :  '
          : 'Distributor Name          :  ' + _SubbrokerName;
      console.log('PDF Service yser type ' + UserType);
      if (parseInt(UserType) == 3) {
        DynamicClientInfo = {
          columns: [
            {
              text:
                'Investor Name           :  ' +
                ClientName +
                '\n' +
                'PAN No.                      :  ' +
                ClientPAN +
                '\n' +
                'Distributor Name          :  ' +
                _SubbrokerName +
                '\n', //added by adarsh 22112023'
              fontSize: 10
            },
            {
              text: 'Report Generated Date : ' + TodaysDate,
              fontSize: 10,
              style: 'ReportDate'
            }
          ]
        };
      } else {
        debugger;
        if (
          (isNullOrUndefined(ClientRMName) || ClientRMName == '') &&
          !isNullOrUndefined(ClientName) &&
          !isNullOrUndefined(ClientPAN)
        ) {
          debugger;
          DynamicClientInfo = {
            columns: [
              {
                text:
                  'Distributor Name          :  ' +
                  _SubbrokerName +
                  '\n' + //added by adarsh
                  'Investor Name           :  ' +
                  ClientName +
                  '\n' +
                  'PAN No.                      :  ' +
                  ClientPAN
                //  + '\n'+
                // 'RM Name                    : ' + ClientRMName + '\n' +
                // 'RM Contact                : ' + ClientRMContact + '\n\n', fontSize: 10
              },
              {
                text: 'Report Generated Date : ' + TodaysDate,
                fontSize: 10,
                style: 'ReportDate'
              }
            ]
          };
        } else {
          DynamicClientInfo = {
            columns: [
              {
                text: 'Distributor Name          :  ' + _SubbrokerName + '\n', //added by adarsh
                fontSize: 10
              },
              {
                text: 'Report Generated Date : ' + TodaysDate,
                fontSize: 10,
                style: 'ReportDate'
              }
            ]
          };
        }
      }
    }

    //#region - Dynamic Logo Logic for Corporate and IFA
    let CompanyLogo = '';
    let TopImage = '';
    let BottomImage = '';
    let headerInfo = {}; //Added by Adarsh 09042025
    let headerInfo1 = {}; //Added by Adarsh 09042025
    let DistributorCompanyName = sessionStorage.getItem(
      'lkighty445dh==CompanyAppName'
    ); //Subbroker_CompanyName;

    let Mobil = this.EncrdecrService.getDecr(
      sessionStorage.getItem('N1QJHdOkO7SBMb8QC')
    );
    let DistributorMobile = Mobil.length > 10 ? Mobil.slice(-10) : Mobil; // GDOM-366 Subbroker_UserMobile

    let DistributorEmail = this.EncrdecrService.getDecr(
      sessionStorage.getItem('V8hpPfITcxhEI9x')
    ); //Subbroker_UserEmail;
    let Flag = sessionStorage.getItem('Vbhs@#%LMKIo='); //Flag > C = Corporate | I = IFA
    //Added by Adarsh 09042025 from here
    headerInfo = {
      columns: [
        {
          text:
            //'AMFI Registered Mutual Fund Distributor' + '\n' +
            DistributorCompanyName +
            '  |  ' +
            +DistributorMobile +
            '  |  ' +
            DistributorEmail +
            '\n\n',
          style: 'Aboveheader',
          alignment: 'center'
        }
      ]
    };
    headerInfo1 = {
      columns: [
        {
          text: 'Prepared for : ' + ClientName + ' ',
          style: 'PreparedFor',
          alignment: 'center'
        }
        // {
        //   text:

        //     'AMFI Registered Mutual Fund Distributor' + '\n' +
        //     this.DistributorCompanyName + ' | ' +
        //     + this.DistributorMobile + ' | ' +
        //     + this.DistributorEmail + '\n\n'
        //   , fontSize: 8,
        //   style: 'Aboveheader', alignment: 'center'
        // },
      ]
    };
    //Added by Adarsh 09042025 till here

    if (Flag != null && Flag != '' && Flag != undefined) {
      let logo = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
      if (logo != null && logo != '' && logo != undefined) {
        //added by adarsh from here
        if (
          environment.CompayName == 'IFA' &&
          environment.IsOptimoney == false
        ) {
          CompanyLogo =
            'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh=='); //added by adarsh
        } else {
          CompanyLogo = logo.toString();
        }
        //to here
      } else {
        CompanyLogo = IFA_logoFile.logoBase64; //Default Logo Image if logo is null
      }
      TopImage = IFA_logoFile.TopImage;
      BottomImage = IFA_logoFile.BottomImage;
    }
    //#endregion

    return {
      //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
      pageSize: 'A4',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 80, 20, 20], // for image logos margin of pdf top , aditya

      // customize: function (doc) {
      //   doc.styles.tableHeader.fontSize = 14;
      //   doc.content[1].table.widths = Array(doc.content[1].table.body[0].length + 1).join('*').split('');
      // },

      // header: function (currentPage, pageCount, pageSize) {
      //   return [
      //     {
      //       // image: logoFile.TopImage,
      //       // //image: pdfLogo,
      //       // absolutePosition: {  // image positioning from margin
      //       //   x: 20, y: 20
      //       // },
      //       // width: 800, height: 95, //image size increase/decrease
      //       // margin: [0, 50, 0, 15],// [left, top, right, bottom]
      //     }
      //   ]
      // },

      header: function (currentPage, _pageCount, _pageSize) {
        let PdfHeaderImg = '';
        ////
        if (Flag === 'C') {
          //corporate
          if (currentPage == 1) {
            PdfHeaderImg = TopImage;
          } else {
            PdfHeaderImg = BottomImage;
          }
          return [
            {
              image: PdfHeaderImg,
              //image: pdfLogo,
              absolutePosition: {
                // image positioning from margin
                x: 20,
                y: 20
              },
              width: 800,
              height: 95, //image size increase/decrease
              margin: [0, 50, 0, 10] // [left, top, right, bottom]
            }
          ];
        } else {
          //IFA
          if (currentPage == 1) {
            PdfHeaderImg = TopImage;
          } else {
            PdfHeaderImg = BottomImage;
          }
          return [
            {
              image: PdfHeaderImg,
              //image: pdfLogo,
              absolutePosition: {
                // image positioning from margin
                x: 20,
                y: 20
              },

              width: 800,
              height: 54, //image size increase/decrease before height is 50
              margin: [0, 80, 0, 10] // [left, top, right, bottom]
            },
            {
              image: CompanyLogo,
              //image: pdfLogo,
              absolutePosition: {
                // image positioning from margin
                x: 720,
                y: 20
              },
              width: 100,
              height: 50 //image size increase/decrease
              //margin: [0, 50, 0, 10],// [left, top, right, bottom]
            }
          ];
        }
      },

      footer: (currentPage, totalPage) => {
        return {
          text: `Page ${currentPage.toString()} of ${totalPage.toString()}`,
          alignment: 'right',
          fontSize: 7,
          margin: [20, 0]
        };
      },
      content: [
        //Added by Adarsh 09042025 from here

        {
          text: 'AMFI REGISTERED MUTUAL FUND DISTRIBUTOR ',
          alignment: 'center',
          fontSize: 8,
          style: 'AMFIText'
        },
        headerInfo,
        {
          canvas: [
            {
              type: 'line',
              x1: 10,
              y1: 0, // Adjust the position according to your layout
              x2: 802, // Adjust the length of the line to match the width
              y2: 0, // Same y-coordinate to make it horizontal
              lineWidth: 0.5,
              lineColor: '#d5d5d5' // Black line color
            }
          ]
        },
        { text: pdfName, style: 'header', alignment: 'center' },
        {
          text: 'Report Generated Date : ' + TodaysDate,
          fontSize: 8,
          style: 'ReportDate',
          alignment: 'center'
        },
        headerInfo1,
        //Added by Adarsh 09042025 till here
        //table 1 - start
        { text: 'Summary', style: 'subheader' }, //margin: [0, 20, 0, 8]
        {
          style: 'tableExample',
          table: {
            headerRows: 1,
            dontBreakRows: true,
            widths: pdfHeader_Width,
            style: 'tableHeader',
            body: pdfData
          },

          // Table Styles
          layout: {
            hLineWidth: function (i, _node) {
              return i === 1 ? 1 : 0;
            },
            vLineWidth: function (_i, _node) {
              return 0;
            },
            hLineColor: function (i, _node) {
              return i === 1 ? '#4CAF50' : '#fff';
            },
            vLineColor: function (_i, _node) {
              return '#fff';
            },
            paddingBottom: function (_i, _node) {
              return 5;
            },
            paddingTop: function (_i, _node) {
              return 5;
            },
            fillColor: function (rowIndex, _node, _columnIndex) {
              switch (rowIndex) {
                case 0:
                  return '#faf8f8';
                  break;
                default:
                  return rowIndex % 2 === 0 ? '#f7f7f7' : '#fff';
                  break;
              }
            }
          }
        },
        //table 1 - end
        {
          text: 'Important Disclosures & Disclaimers: ',
          style: 'subheader',
          fontSize: 12
        },
        {
          text:
            'This statement/report is computer system generated, based on the information available with the help of different data sources and service providers.' +
            '\n' +
            'I am/We are an AMFI Registered Distributor. Any valuations quoted are the most recent available. However, there may be delays in updating the records or there may be changes that we are not aware of. If the reader comes across any errors or omissions, please inform us immediately.' +
            '\n' +
            'I/We shall not take any responsibility for any error, omission, inaccuracy, or mistake of any nature, or any consequences of the use of the material/information provided in the report, and I/We shall not be held liable for any direct or indirect damages or loss, if any, resulting from any investment made by the investors.' +
            '\n' +
            'The tax calculations are made based on our interpretation of the Income Tax Act. Tax benefits are as per extant tax laws and are subject to changes. Investors should consult their tax consultant for any taxation advice/implications.' +
            '\n' +
            'The maturity date, wherever displayed, is based on available information.' +
            '\n' +
            'The information provided herein is meant only for general reading purposes and the views being expressed only constitute opinions. Investments in mutual funds should not be construed as a guarantee of any minimum returns. Past performance may or may not be sustained in the future. There is no capital protection guarantee or assurance of any return in mutual fund investments.' +
            '\n' +
            'Investors alone shall be fully responsible/liable for any decision taken in mutual fund investments. Mutual fund investments are subject to market risks; read all scheme-related documents carefully.',
          fontSize: 10
        }
      ],

      styles: {
        Aboveheader: {
          fontSize: 10,
          bold: true,
          margin: [0, 5, 0, 10],
          color: '#000',
          text: 'Uppercase'
        },
        AMFIText: {
          // bold: true,
          fontSize: 8,
          color: 'rgb(0 0 0 / 70%)',
          margin: [0, 10, 0, 0],
          text: 'Uppercase'
        },
        PreparedFor: {
          fontSize: 12,
          bold: true,
          margin: [0, 20, 0, 20],
          color: '#000',
          text: 'Uppercase'
        },
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 20, 0, 8],
          color: '#000',
          text: 'Uppercase'
        },
        subheader: {
          fontSize: 9,
          bold: true,
          margin: [0, 15, 0, 4],
          color: '#000'
        },
        ReportDate: {
          alignment: 'centre',
          color: '#000'
        },
        tableExample: {
          //fontSize: 10,
          margin: [10, 5, 0, 15]
        },
        tableHeader: {
          fontSize: 10,
          bold: true
        }
      },
      defaultStyle: {
        //font : 'SegoeUI',
        fontSize: 7,
        color: '#000'
      }
    };
  }

  SentToMailbase64pdf(data, PdfName, ClientBasicInfoId) {
    this.NSE.sendPdfReportToClient(data, PdfName, ClientBasicInfoId).subscribe(
      (data) => {
        debugger;
        let output = JSON.stringify(data);
        this.pdfMailSubjectObj.next(output);
      }
    );
  }
}
